module.exports = __webpack_public_path__ + "img/copy-icon.51df3c1f.svg";